import { Button, Divider, Grid } from "@mui/material";
import { useMemo } from "react";
import type { ReportAccessType } from "@entrilia/shared/api/reportAccessTypes.ts";
import DialogHeader from "@entrilia/shared/components/dialog/DialogHeader";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import CopyReportContent from "./CopyReportContent";
import type { ReportValidationType } from "./hooks/useReportValidation";
import type { ReportInfo } from "../../../../../../api/types/svTypes.ts";

interface CopyToDialogSelectionProps {
  reports: ReportInfo[];
  reportValidation: ReportValidationType;
  copyConditionValues: boolean;
  copyAccess: ReportAccessType;
  inheritFromParent: boolean;
  onCopy: () => void;
  onClose: () => void;
  onCopyConditionValues: (value: boolean) => void;
  onCopyAccess: (value: ReportAccessType) => void;
  onInheritFromParent: (value: boolean) => void;
}
export function CopyToDialogSelection({
  reports,
  reportValidation,
  copyConditionValues,
  copyAccess,
  inheritFromParent,
  onCopy,
  onClose,
  onCopyConditionValues,
  onCopyAccess,
  onInheritFromParent,
}: CopyToDialogSelectionProps) {
  const copyAvailable = useMemo(() => {
    return (
      reportValidation.selectedCompanies.length > 0 &&
      reportValidation.selectedCompanies.every((c) =>
        c.reports.every((r) => r.validated && r.result?.hasRequiredDataset)
      )
    );
  }, [reportValidation.selectedCompanies]);

  return (
    <>
      <DialogHeader text={`Copy Report${reports.length > 1 ? "s" : ""}`} onClose={onClose} />
      <Divider />
      <Grid container sx={{ flex: 1, width: "100%" }}>
        <CopyReportContent
          validation={reportValidation}
          copyConditionValues={copyConditionValues}
          copyAccess={copyAccess}
          inheritFromParent={inheritFromParent}
          onCopyConditionValues={onCopyConditionValues}
          onCopyAccess={onCopyAccess}
          onInheritFromParent={onInheritFromParent}
        />
      </Grid>
      <Divider />
      <DialogButtons onCancel={onClose}>
        <Button variant="contained" disabled={!copyAvailable} onClick={onCopy}>
          Copy Report
        </Button>
      </DialogButtons>
    </>
  );
}
